import { inject, Injectable } from "@angular/core";
import { CanDeactivate, Router } from "@angular/router";
import { Observable } from "rxjs";

import { AnamneseComponent } from "../anamnese.component";
import { LoadingBarService } from "@ngx-loading-bar/core";

@Injectable({
	providedIn: "root"
})
export class AnamneseDeactivateGuard implements CanDeactivate<AnamneseComponent> {
	private readonly loadingBar = inject(LoadingBarService);
	private router = inject(Router);
	canDeactivate(component: AnamneseComponent): Observable<boolean> | boolean {
		if(this.router.currentNavigation().finalUrl?.toString() === '/signin'){
			return true;
		}
		// Surpress the loading bar when opening the confirmation dialog
		const routerLoader = this.loadingBar.useRef('router');
		if(routerLoader){
			routerLoader.complete();
		}
		return component.canDeactivate();
	}
}
